<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p" id="part01"><a id="page_5"></a><span class="border"> <span class="small">I</span> </span><br/><br/><em>The Basics</em><a id="page_6"></a></h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?6c15a12b